


































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import layout from '@/layouts/app-layout.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import enquiryList from '@/components/enquiry-list.vue';
import { EnquiryApi } from '@/api/enquiry-api';
import { ActionConstants } from '@/stores/enquiries/action-constants';
import Enquiry from '@/pages/enquiry.vue';
import debounce from 'lodash.debounce';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';

const enquiryModule = namespace('enquiry');
const userModule = namespace('user');

@Component({
    components: {
        layout,
        breadcrumb,
        enquiryList,
    },
})
export default class Enquiries extends Vue {
    public isLoading: boolean = true;
    @enquiryModule.Getter('allEnquiriesTotalPages') public totalPages: number;
    @enquiryModule.Getter('allEnquiriesPageSize') public currentPageSize: number;
    @enquiryModule.Getter('allEnquiriesTotal') public totalEnquiries: number;
    @enquiryModule.Getter('allEnquiries') public enquiries: Array<Enquiry>;
    @enquiryModule.Getter('allEnquiriesPage') public currentPage: number;
    @enquiryModule.Getter('allEnquiriesKeyword') public keyword: string | null;
    @enquiryModule.Getter('allEnquiriesFilterStatus') public filterStatus: Array<Enquiry>;
    @enquiryModule.Getter('allEnquiriesFrom') public from: string | null;
    @enquiryModule.Getter('allEnquiriesTo') public to: string | null;
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @userModule.Getter('currentSite') public currentSite: Site | null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetch, { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
    }
    @Watch('currentSite')
    public async onSiteChanged(value: Site): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetch, { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
    }
    public async handlePageChanged(value: number): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllEnquiriesPage, value);
        await this.$store.dispatch(ActionConstants.fetch, { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: null, to: null });

        this.isLoading = false;
    }
    public async handlePageSizeChanged(value: number): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllEnquiriesPageSize, value);
        await this.$store.dispatch(ActionConstants.fetch, { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: null, to: null });

        this.isLoading = false;
    }
    public handleKeywordChanged = debounce(this.handleKeywordChangedInternal, 750);
    private async handleKeywordChangedInternal(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllEnquiriesKeyword, value);
        await this.$store.dispatch(ActionConstants.updateAllEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async handleStatusChanged(value: number | string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllEnquiriesFilterStatus, value);
        await this.$store.dispatch(ActionConstants.updateAllEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async handleFromChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllEnquiriesFrom, value);
        await this.$store.dispatch(ActionConstants.updateAllEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async handleToChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllEnquiriesTo, value);
        await this.$store.dispatch(ActionConstants.updateAllEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.$store.dispatch(ActionConstants.updateAllEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
        this.isLoading = false;
    }
}
